module.exports = __webpack_public_path__ + "img/trust.7492c0c1.png";